import React from "react";
import Service from './search/service'
import cross from './pics/svg/cross.svg'
import dots from './pics/svg/dots.svg'
import Flags from './search/flags'
import Imdb from './pics/imdb.png'
import NetflixText from './pics/services/netflix-text.png';
import firebase from 'firebase/app';

function Fav({fav}) {

    let countries = fav.countries,
        moreClicked = false

    function checkCountries() {
        let lastItem = countries[countries.length - 1];
        if (lastItem[1] === ":") {
            lastItem = lastItem.replace("e:+", "")
            countries[countries.length - 1] = lastItem + " more!"
        }
    }
    if (countries.length > 0) {
        checkCountries()
    }

    function onRemoveClick() {
        let user = firebase.auth().currentUser, 
        db = firebase.firestore(), 
        favToRemove = {
            id: fav.id,
            name: fav.name,
            pic: fav.pic,
            services: fav.services,
            countries: fav.countries
        }

        let userRef = db.collection('users').doc(user.uid);
        userRef.update({
            "favourites": firebase.firestore.FieldValue.arrayRemove(favToRemove)
        });
    }

    function onMoreClick() {
        moreClicked ? hideMore() : showMore()
        moreClicked = !moreClicked
    }

    function showMore() {
        document.querySelector(`.fav.${fav.id} .top .more`).style.transform = "rotate3d(0,0,0,90deg)"
        document.querySelector(`.fav.${fav.id} .top .main .imdb`).style.pointerEvents = "all"
        document.querySelector(`.fav.${fav.id} .top .main .imdb .imdb-logo`).style.opacity = 1
        document.querySelector(`.fav.${fav.id} .top .main .imdb .imdb-logo`).style.transform = 'translateX(0px)'
        document.querySelector(`.fav.${fav.id}`).style.background = "#00000011"
        
        document.querySelector(`.fav.${fav.id} .info`).style.pointerEvents = "all"
        let extendedHeight = document.querySelector(`.fav.${fav.id} .info`).clientHeight
        document.querySelector(`.fav.${fav.id}`).style.height = `${92 + extendedHeight}px`
        
    }
    function hideMore() {
        document.querySelector(`.fav.${fav.id} .top .more`).style.transform = "rotate3d(0,0,1,90deg)"
        document.querySelector(`.fav.${fav.id} .top .main .imdb`).style.pointerEvents = "none"
        document.querySelector(`.fav.${fav.id} .top .main .imdb .imdb-logo`).style.opacity = 0
        document.querySelector(`.fav.${fav.id} .top .main .imdb .imdb-logo`).style.transform = 'translateX(-20px)'
        document.querySelector(`.fav.${fav.id}`).style.background = "none"
        document.querySelector(`.fav.${fav.id} .info`).style.pointerEvents = "none"
        document.querySelector(`.fav.${fav.id}`).style.height = "92px"
    }

    function favMouseLeave() {
        if (moreClicked) {
            hideMore()
            moreClicked = !moreClicked
        }
        
    }

    return (
        <div onMouseLeave={favMouseLeave} className={`fav ${fav.id}`}>
            <div className="top">
                <div className="main">
                    <a className='imdb' href={`https://www.imdb.com/title/${fav.id}`} target="_blank" rel="noopener noreferrer">
                        <img className="imdb-logo" src={Imdb} alt="imdb"/>
                        <img className="pic" src={fav.pic} alt={fav.name} />
                    </a>
                    <h3>{fav.name}</h3>
                </div>
                <img className="more" onClick={onMoreClick} src={dots} alt="more..."/>
            </div>
            
            <div className="info">
                <div className="services">
                    {fav.services.map((service) => (
                        <Service key={service.name} service={service} />
                    ))}
                </div>
                <div className={`countries-container ${fav.id}`}>
                    <h4>Available on&nbsp;<span><img src={NetflixText} alt="Netflix"/></span>&nbsp;in these countries:</h4>
                    <div className="countries">
                        {countries.map(
                            country => <div className="country" key={country}> {`${!(country[country.length - 1] === "!") ? Flags[country] : "Plus "} ${country}`} </div>
                        )}
                    </div>         
                </div>
                <button onClick={onRemoveClick}><img src={cross} alt="X"/></button>
            </div>
        </div>
    );
}

export default Fav;
